import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getConfigText, newLineParser } from "../utils";
import TranscriptionVideo from '../components/TranscriptionVideo';

export default function StartSkillPage({ pageId }) {

    const [feedbackVisible, setFeedbackVisible] = React.useState(false);

    return (
        <React.Fragment>
            <Typography variant="body2" gutterBottom>
                {newLineParser(getConfigText(pageId, "inleiding"))}
            </Typography>

            <Typography variant="body2" gutterBottom component="div">
                <TranscriptionVideo src={getConfigText(pageId, "inleiding_film")} transcription={getConfigText(pageId, "inleiding_film_transcriptie")} onEnded={() => setFeedbackVisible(true)} />
            </Typography>

            {feedbackVisible ? (
                <Typography variant="body2" gutterBottom>
                    Klik op volgende om naar de eerste oefening te gaan.
                </Typography> 
            ) : null}
                       

        </React.Fragment>
    );
}
